export { TrailingIcon19 } from "./TrailingIcon19";
